import client from 'braintree-web/client';
import { applePay, paypal } from 'braintree-web';
import axios from './axios';

async function tokenizeAndCreateBraintreePaymentMethod({
  tokenizationKey,
  authToken,
  onBehalfUserId,
  card,
}) {
  const http = axios({ authToken });

  try {
    const clientInstance = await client.create({
      authorization: tokenizationKey,
    });

    const response = await clientInstance.request({
      endpoint: 'payment_methods/credit_cards',
      method: 'post',
      data: {
        creditCard: card,
      },
    });
    // check for prepaid cards
    const creditCard = response.creditCards[0];
    if(creditCard && creditCard.binData){
      if(window.gon.block_prepaid_cards) {
        if(creditCard.binData.prepaid == 'Yes') {
          throw('PaymentErrorPrepaidCard');
          return;
        }
      }
    }
    const { nonce } = creditCard;

    const paymentMethodResponse = await http.post(
      `/users/${onBehalfUserId || 'me'}/payments/methods/braintree`,
      {
        payment_method_nonce: nonce,
      },
    );

    return paymentMethodResponse;
  } catch (e) {
    console.log(e);
    throw (e);
  }
}

// create the braintree client instance for paypal
async function createPayPalBraintreePaymentInstance({
  tokenizationKey,
  authToken,
}) {
  try {
    const clientInstance = await client.create({
      authorization: tokenizationKey,
    });

    const paypalClientInstance = await paypal.create({
      client: clientInstance,
      authorization: tokenizationKey,
    });

    return paypalClientInstance;
  } catch (e) {
    console.log(e);
  }

  return null;
}

async function tokenizeAndCreatePayPalPaymentMethod({
  paypalPaymentInstance,
  authToken,
}) {
  const http = axios({ authToken });

  try {
    const response = await paypalPaymentInstance.tokenize({
      flow: 'vault',
    });
    console.log('RESPONSE: ', response);
    const { nonce } = response;

    const paymentMethodResponse = await http.post(
      '/users/me/payments/methods/braintree',
      {
        payment_method_nonce: nonce,
      },
    );

    return paymentMethodResponse;
  } catch (e) {
    console.log(e);
  }

  return null;
}

async function checkApplePay() {
  return (window.ApplePaySession
    && ApplePaySession.supportsVersion(3)
    && ApplePaySession.canMakePayments());
}

// create the braintree client instance for apple pay
async function createApplePayBraintreePaymentInstance({
  tokenizationKey,
  authToken,
}) {
  if (window.ApplePaySession === undefined) {
    return null;
  }

  const applePayEnabled = await checkApplePay();
  if (!applePayEnabled) {
    return null;
  }

  try {
    // returns a promise if  no call back is provided
    // so we can await this
    const clientInstance = await client.create({
      authorization: tokenizationKey,
    });
    // returns synchronously if deferred client is not provided
    const applePayClientInstance = applePay.create({
      client: clientInstance,
      authorization: tokenizationKey,
    });

    return applePayClientInstance;
  } catch (e) {
    console.log(e);
  }

  return null;
}

// break up applepay into smaller portions
async function createApplePayPaymentRequest({
  applePayPaymentInstance,
  authToken,
  label,
  amount,
}) {
  try {
    const paymentRequest = applePayPaymentInstance.createPaymentRequest({
      total: {
        label,
        amount,
      },
    });
    return paymentRequest;
  } catch (e) {
    console.log(e);
  }
  return null;
}

async function createApplePayPaymentSession({
  paymentRequest,
  onPaymentAuthorized,
  onValidateMerchant,
}) {
  try {
    const session = new ApplePaySession(3, paymentRequest);
    session.onpaymentauthorized = onPaymentAuthorized;
    session.onvalidatemerchant = onValidateMerchant;
    return (session);
  } catch (e) {
    console.log(e);
  }
  return null;
}

export {
  tokenizeAndCreateBraintreePaymentMethod,
  tokenizeAndCreatePayPalPaymentMethod,
  createPayPalBraintreePaymentInstance,
  createApplePayBraintreePaymentInstance,
  createApplePayPaymentRequest,
  createApplePayPaymentSession,
};
